import { Controller } from 'stimulus'

export default class extends Controller {
    trimWhiteSpace() {
        this.element.value = this.element.value.trim()
    }
}
